export default "__VITE_ASSET__WJtFipjT__"